import React from 'react'
import { useNavigate } from 'react-router-dom'

import FocusableCard from './FocusableCard'

import type { SeeAllCardProps } from './types'

export const SeeAllCard = ({
  url,
  index,
  onFocus,
  layout,
  ttsCounterText,
}: SeeAllCardProps) => {
  const navigate = useNavigate()
  const handleOnEnterPress = () => {
    navigate(url)
  }

  return (
    <FocusableCard
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={`${ttsCounterText} .... See all`}
      onEnterPress={handleOnEnterPress}
    >
      <div className="card-see-all">See all</div>
    </FocusableCard>
  )
}
